export enum BackgroundSizeType {
  Auto = 0,
  Contain = 1,
  Cover = 2,
}
